import * as i0 from '@angular/core';
import { ElementRef, NgZone, Injectable, Inject, Self, Directive, Output, NgModule } from '@angular/core';
import * as i1 from '@taiga-ui/cdk';
import { tuiGetElementOffset, tuiScrollFrom, tuiZoneOptimized, TuiDestroyService } from '@taiga-ui/cdk';
import { SCROLL_REF_SELECTOR, TUI_SCROLL_REF } from '@taiga-ui/core';
import { Observable } from 'rxjs';
import { take, switchMap, map, startWith, distinctUntilChanged, skip, takeUntil } from 'rxjs/operators';

class TuiElasticStickyService extends Observable {
    constructor(scrollRef, { nativeElement }, ngZone, destroy$) {
        super(subscriber => ngZone.onStable
            .pipe(take(1), switchMap(() => {
            const host = nativeElement.closest(SCROLL_REF_SELECTOR) ||
                scrollRef.nativeElement;
            const { offsetHeight } = nativeElement;
            const { offsetTop } = tuiGetElementOffset(host, nativeElement);
            return tuiScrollFrom(host).pipe(map(() => Math.max(1 -
                Math.max(Math.round(host.scrollTop) - offsetTop, 0) /
                    offsetHeight, 0)));
        }), startWith(1), distinctUntilChanged(), skip(1), tuiZoneOptimized(ngZone), takeUntil(destroy$))
            .subscribe(subscriber));
    }
}
TuiElasticStickyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyService, deps: [{ token: TUI_SCROLL_REF }, { token: ElementRef }, { token: NgZone }, { token: TuiDestroyService, self: true }], target: i0.ɵɵFactoryTarget.Injectable });
TuiElasticStickyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [TUI_SCROLL_REF]
                }] }, { type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: i0.NgZone, decorators: [{
                    type: Inject,
                    args: [NgZone]
                }] }, { type: i1.TuiDestroyService, decorators: [{
                    type: Self
                }, {
                    type: Inject,
                    args: [TuiDestroyService]
                }] }]; } });

class TuiElasticStickyDirective {
    constructor(elasticStickyService) {
        this.tuiElasticSticky = elasticStickyService;
    }
}
TuiElasticStickyDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyDirective, deps: [{ token: TuiElasticStickyService }], target: i0.ɵɵFactoryTarget.Directive });
TuiElasticStickyDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiElasticStickyDirective, selector: "[tuiElasticSticky]", outputs: { tuiElasticSticky: "tuiElasticSticky" }, providers: [TuiElasticStickyService, TuiDestroyService], exportAs: ["tuiElasticSticky"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiElasticSticky]',
                    exportAs: 'tuiElasticSticky',
                    providers: [TuiElasticStickyService, TuiDestroyService],
                }]
        }], ctorParameters: function () { return [{ type: TuiElasticStickyService, decorators: [{
                    type: Inject,
                    args: [TuiElasticStickyService]
                }] }]; }, propDecorators: { tuiElasticSticky: [{
                type: Output
            }] } });

class TuiElasticStickyModule {
}
TuiElasticStickyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiElasticStickyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyModule, declarations: [TuiElasticStickyDirective], exports: [TuiElasticStickyDirective] });
TuiElasticStickyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiElasticStickyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiElasticStickyDirective],
                    exports: [TuiElasticStickyDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiElasticStickyDirective, TuiElasticStickyModule, TuiElasticStickyService };
